import React from 'react';
export function AuthorityStatement() {
  const connections = ['Strategic positioning', 'Structured prompt generation', 'Multi-asset production', 'Quality scoring and repair', 'Direct publishing', 'CRM conversation tracking', 'Pipeline attribution'];
  return <section id="system" className="w-full py-16 md:py-24 px-4 bg-muted/30" data-id="element-8">
      <div className="container max-w-5xl mx-auto" data-id="element-9">
        <h2 className="text-3xl md:text-4xl lg:text-5xl font-semibold text-foreground mb-8 text-center leading-tight" data-id="element-10">
          This Is Not an AI Writing Tool.
        </h2>

        <div className="space-y-8 text-lg" data-id="element-11">
          <p className="text-xl font-semibold text-foreground text-center leading-relaxed" data-id="element-12">
            WisePilot is a governed AI operating system for marketing execution.
          </p>

          <p className="text-muted-foreground text-center leading-relaxed" data-id="element-13">
            It connects:
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 py-4" data-id="element-14">
            {connections.map((connection, index) => <div key={index} className="flex items-center gap-3 bg-card rounded-lg p-4 border border-border shadow-sm hover:shadow-md transition-shadow" data-id="element-15">
                <div className="flex-shrink-0 w-2 h-2 rounded-full bg-[hsl(var(--brand-blue-light))] dark:bg-[hsl(var(--brand-blue-dark))]" data-id="element-16" />
                <span className="text-base font-medium text-foreground" data-id="element-17">
                  {connection}
                </span>
              </div>)}
          </div>

          <div className="space-y-4 pt-6 text-center max-w-4xl mx-auto" data-id="element-18">
            <p className="text-muted-foreground leading-relaxed" data-id="element-19">
              Every output is controlled. Every revision is tracked. Every asset
              feeds the system.
            </p>

            <p className="text-xl font-bold text-foreground leading-relaxed" data-id="element-20">
              Content stops being creative guesswork. It becomes a compounding
              revenue engine.
            </p>
          </div>
        </div>
      </div>
    </section>;
}